"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStripeEnabledContext = exports.useStripeContext = exports.buildEndpointError = exports.StripeDisabledContextProvider = exports.StripeEnabledContextProvider = void 0;
var stripe_js_1 = require("@stripe/stripe-js");
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var AcceptFlowContextProvider_1 = require("../AcceptFlowContextProvider");
var StripeContext = react_1.default.createContext(undefined);
var StripeEnabledContextProvider = function (_a) {
    var children = _a.children, stripePublicKey = _a.stripePublicKey, stripeUserId = _a.stripeUserId;
    var publicApiBaseUrl = (0, inversify_react_1.useOptionalInjection)("publicApiBaseUrl");
    var secretHash = (0, inversify_react_1.useOptionalInjection)("secretHash");
    var elementsRef = (0, react_1.useRef)();
    var isPreviewAccept = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)().isPreviewAccept;
    var addPayment = function (payload, billingDetails) { return __awaiter(void 0, void 0, void 0, function () {
        var elements, stripe, submitError, clientSecret, _a, error, setupIntent;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!publicApiBaseUrl || !secretHash) {
                        throw new Error("Not setup for payments.");
                    }
                    elements = elementsRef.current;
                    if (!elements) {
                        throw new Error("No active payment to confirm.");
                    }
                    return [4, stripePromise];
                case 1:
                    stripe = _b.sent();
                    return [4, elements.submit()];
                case 2:
                    submitError = (_b.sent()).error;
                    if (submitError) {
                        throw new Error("stripe validation error");
                    }
                    return [4, createPaymentSetupIntent({
                            linkSecret: secretHash,
                            payment: {
                                name: (billingDetails === null || billingDetails === void 0 ? void 0 : billingDetails.name) || payload.payment.name,
                                email: (billingDetails === null || billingDetails === void 0 ? void 0 : billingDetails.email) || payload.payment.email,
                            },
                        })];
                case 3:
                    clientSecret = (_b.sent()).clientSecret;
                    return [4, stripe.confirmSetup({
                            elements: elements,
                            clientSecret: clientSecret,
                            confirmParams: {
                                payment_method_data: {
                                    billing_details: billingDetails,
                                },
                                return_url: window.location.href,
                            },
                            redirect: "if_required",
                        })];
                case 4:
                    _a = _b.sent(), error = _a.error, setupIntent = _a.setupIntent;
                    if (error) {
                        console.error(error);
                        throw new Error("Couldn't confirm payment details. (error: ".concat(error.code, ")"));
                    }
                    return [4, addPaymentDetails({
                            configuredQuotes: payload.configuredQuotes,
                            linkSecret: secretHash,
                            payment: {
                                amount: payload.payment.amount,
                                currency: payload.payment.currency,
                                setupIntentId: setupIntent.id,
                            },
                            sessionStartedAt: payload.sessionStartedAt,
                        })];
                case 5:
                    _b.sent();
                    return [2];
            }
        });
    }); };
    var createPaymentSetupIntent = function (data) { return __awaiter(void 0, void 0, Promise, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.post("".concat(publicApiBaseUrl, "/payments/setup-intents"), data, {
                            withCredentials: true,
                        })];
                case 1:
                    response = _a.sent();
                    return [2, response.data];
                case 2:
                    error_1 = _a.sent();
                    throw (0, exports.buildEndpointError)(error_1);
                case 3: return [2];
            }
        });
    }); };
    var addPaymentDetails = function (data) { return __awaiter(void 0, void 0, Promise, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.post("".concat(publicApiBaseUrl, "/payments/payment-details"), data, { withCredentials: true })];
                case 1:
                    _a.sent();
                    return [3, 3];
                case 2:
                    error_2 = _a.sent();
                    throw (0, exports.buildEndpointError)(error_2);
                case 3: return [2];
            }
        });
    }); };
    var stripePromise = (0, react_1.useMemo)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var stripe;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, (0, stripe_js_1.loadStripe)(stripePublicKey, {
                        stripeAccount: stripeUserId,
                        apiVersion: "2024-09-30.acacia",
                    })];
                case 1:
                    stripe = _a.sent();
                    if (!stripe) {
                        throw new Error("Stripe failed to load");
                    }
                    return [2, stripe];
            }
        });
    }); }, [stripePublicKey, stripeUserId]);
    var createStripeElements = (0, react_1.useCallback)(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var stripe, elements;
        var currency = _b.currency;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4, stripePromise];
                case 1:
                    stripe = _c.sent();
                    elements = stripe.elements({
                        mode: "setup",
                        currency: currency.toLowerCase(),
                        paymentMethodOptions: {
                            us_bank_account: {
                                verification_method: "instant",
                            },
                        },
                    });
                    if (!isPreviewAccept) {
                        elementsRef.current = elements;
                    }
                    return [2, elements];
            }
        });
    }); }, []);
    return (react_1.default.createElement(StripeContext.Provider, { value: {
            createStripeElements: createStripeElements,
            addPayment: addPayment,
            enabled: true,
        } }, children));
};
exports.StripeEnabledContextProvider = StripeEnabledContextProvider;
var StripeDisabledContextProvider = function (_a) {
    var children = _a.children;
    return react_1.default.createElement(StripeContext.Provider, { value: { enabled: false } }, children);
};
exports.StripeDisabledContextProvider = StripeDisabledContextProvider;
var buildEndpointError = function (error) {
    var _a;
    if (axios_1.default.isAxiosError(error)) {
        var responseData = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
        if (responseData === null || responseData === void 0 ? void 0 : responseData.message) {
            return new Error(responseData.message);
        }
    }
    return new Error("It looks like there was a network error. Please check your connection and try again.");
};
exports.buildEndpointError = buildEndpointError;
var useStripeContext = function () {
    var stripeContext = react_1.default.useContext(StripeContext);
    if (!stripeContext) {
        throw new Error("useStripeContext can only be used inside a StripeContextProvider");
    }
    return stripeContext;
};
exports.useStripeContext = useStripeContext;
var useStripeEnabledContext = function () {
    var stripeContext = (0, exports.useStripeContext)();
    if (!stripeContext.enabled) {
        throw new Error("useStripeEnabledContext can only be used in a context where Stripe is enabled");
    }
    return stripeContext;
};
exports.useStripeEnabledContext = useStripeEnabledContext;
